{
 "base_frame": 0,
 "bbox": [
  250,
  357,
  399,
  563
 ],
 "visemes": [
  "sil",
  "AA",
  "OH",
  "EE",
  "OO",
  "MM",
  "FF",
  "LL",
  "TH",
  "AH_open"
 ],
 "picked_musetalk_frame": {
  "AA": 10,
  "OH": 13,
  "EE": 6,
  "OO": 22,
  "MM": 14,
  "FF": 52,
  "LL": 38,
  "TH": 51,
  "AH_open": 46
 }
}